import dynamic from 'next/dynamic';
import React from 'react';

// FAANG-GRADE: Dynamic imports to prevent SSR issues
const LayoutRouter = dynamic(() => import('./LayoutRouter'), {
  ssr: false,
  loading: () => (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'system-ui, sans-serif'
    }}>
      Loading...
    </div>
  )
});

interface LayoutProps {
  children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return <LayoutRouter>{children}</LayoutRouter>;
};

export default Layout;
